<div class="page-wrapper">
  <ng-container>
    <sc-placeholder name="jss-eq-menu" [rendering]="route" ></sc-placeholder>
  </ng-container>
  <main>
    <ng-container>
      <app-visitor-identification></app-visitor-identification>
      <sc-placeholder name="jss-main" [rendering]="route"></sc-placeholder>
    </ng-container>
  </main>
  <ng-container>
    <sc-placeholder name="jss-eq-footer" [rendering]="route" ></sc-placeholder>
  </ng-container>
</div>
